import * as React from "react"

function SvgCheck(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5.083A5.419 5.419 0 00.083 5.5 5.419 5.419 0 005.5 10.917 5.419 5.419 0 0010.917 5.5 5.419 5.419 0 005.5.083zm0 9.75A4.34 4.34 0 011.167 5.5 4.34 4.34 0 015.5 1.167 4.34 4.34 0 019.833 5.5 4.34 4.34 0 015.5 9.833zM4.417 6.675l3.57-3.57.763.77-4.333 4.333L2.25 6.042l.764-.764 1.403 1.397z"
        fill="#A0A8B2"
      />
    </svg>
  )
}

export default SvgCheck

